import { jsxs as e, jsx as c } from "react/jsx-runtime";
import { c as l, h as o } from "../../_chunks/VideoPlayerIcons.css.CABSRJZT.js";
const L = ({ size: r = 62 }) => /* @__PURE__ */ e(
  "svg",
  {
    width: r,
    height: r,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ c("circle", { cx: "32", cy: "32", r: "31", className: l }),
      /* @__PURE__ */ c("g", { clipPath: "url(#clip0_17083_15706)", children: /* @__PURE__ */ c(
        "path",
        {
          className: o,
          d: "M30.9121 20.6305C31.3083 20.223 31.9997 20.5037 32 21.0719V44.0094C32 44.578 31.3084 44.8585 30.9121 44.4509L24.2695 37.6188C24.1503 37.4962 23.9865 37.4264 23.8154 37.4264H18.3838C18.0341 37.4264 17.7502 37.1433 17.75 36.7936V28.2887C17.75 27.939 18.034 27.655 18.3838 27.655H23.8154C23.9864 27.655 24.1503 27.586 24.2695 27.4635L30.9121 20.6305ZM44.1611 28.0241C44.6387 27.5469 45.4132 27.5467 45.8906 28.0241C46.3677 28.5015 46.3675 29.2751 45.8906 29.7526L42.6787 32.9635L45.8906 36.1755L45.9746 36.2682C46.3663 36.7484 46.338 37.4572 45.8906 37.905C45.4429 38.3526 44.7342 38.3807 44.2539 37.9889L44.1611 37.905L40.9492 34.693L37.7383 37.905L37.6455 37.9889C37.1653 38.3804 36.4574 38.3523 36.0098 37.905C35.5322 37.4274 35.5322 36.653 36.0098 36.1755L39.2197 32.9635L36.0098 29.7526C35.5322 29.2751 35.5322 28.5016 36.0098 28.0241C36.4873 27.5469 37.2609 27.5467 37.7383 28.0241L40.9492 31.2341L44.1611 28.0241Z"
        }
      ) })
    ]
  }
);
export {
  L as VideoPlayerSoundOffIcon
};
